module.exports = __webpack_public_path__ + "by.svg?e25ab03c7f24154c6a1caed11bb16a5f";